"use client";

import { useMemo } from "react";
import Image from "next/image";
import { Header } from "@/components/quiz/explainers/header";
import { Button } from "@workspace/ui/components/button";
import explainersJson from "@/lib/data/explainers.json";

type RC2Model = {
  id: "regular-cycle-analysis-2";
  title: string;
  description: string;
  image: string;
};

export default function RegularCycleExplainer2({
  title,
  image,
  image_description,
  handleNext,
}: {
  title: string;
  image?: string;
  image_description?: string;
  handleNext: () => void;
}) {
  const model = useMemo(() => {
    const all = (explainersJson as any)?.explainers ?? [];
    return all.find(
      (e: any) => e?.id === "regular-cycle-analysis-2"
    ) as RC2Model;
  }, []);

  const alt = model.title.replace(/<[^>]*>/g, "");

  return (
    <>
      <div className="flex flex-1 flex-col gap-6 overflow-y-auto min-h-0 pb-12">
        <Header
          title={title}
          description={model.description}
          descriptionClassName="text-[#122D35]"
        />
        <div className=" rounded-[16px]">
          <div className="relative h-[300px] md:h-[400px] w-full">
            <Image
              src={model.image}
              fill
              alt={alt || "regular-cycle-analysis"}
              className="object-contain"
              sizes="100vw"
            />
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
        <Button onClick={handleNext} variant="default" className="w-full shrink-0">Next</Button>
      </div>
    </>
  );
}
